import { externalLink } from "@/routes/_constants/external-link";

import type { ReferenceArticle } from "../../_shared/reference-articles/types";

export const REFERENCE_ARTICLES: ReferenceArticle[] = [
	{
		title: "ねっぱん！と連携する方法",
		thumbnailUrl: "/assets/site-controller/reference-articles/neppan/settings.jpg",
		url: `${externalLink.faqSite}/faq/host/site-controller/3c9fffe15c57811294cdc9a1bdb9013e`,
	},
];
